export default __webpack_public_path__ + "static/media/Group1802.18296396.svg";